import { Media } from 'components/UI/V3/MediaViewer/MediaViewer';
import styles from 'components/UI/V3/MediaViewer/Thumbnail/MediaViewerThumbnail.module.scss';
import React from 'react';

interface MediaViewerThumbnailProps {
    media: Media;
    active?: boolean;
    onClick?: () => void;
}

export const MediaViewerThumbnail: React.FC<MediaViewerThumbnailProps> = ({ media, active, onClick }) => {
    return (
        <div
            data-active={active}
            className={styles.root}
            onClick={onClick}
        >
            {media.type === 'image' && (
                <img
                    alt={media.type}
                    src={media.thumbnailUrl || media.src}
                />
            )}

            {media.type === 'video' && (
                <video
                    className={styles.video}
                    preload="metadata"
                    muted
                    playsInline
                    disablePictureInPicture
                    disableRemotePlayback
                    src={media.src}
                />
            )}
        </div>
    );
};
